import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneLoginFormViewCmsKey =
    | 'phonenumberPlaceholder'
    | 'passwordPlaceholder'
    | 'phoneSignInButton'
    | 'createAccount'
    | 'ForgotPassword'
    | 'otpLogin'
    | 'CapsLockWarning';

export const PhoneLoginFormViewCmsWithDefault: CmsObjectWithDefault<PhoneLoginFormViewCmsKey> = {
    phonenumberPlaceholder: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    passwordPlaceholder: {
        cmsId: 59994,
        defaultTranslation: 'Password',
    },
    phoneSignInButton: {
        cmsId: 61924,
        defaultTranslation: 'Sign in',
    },
    createAccount: {
        cmsId: 101957,
        defaultTranslation: 'Create account',
    },
    ForgotPassword: {
        cmsId: 59489,
        defaultTranslation: 'Forgot password',
    },
    otpLogin: {
        cmsId: 117746,
        defaultTranslation: 'Login/Sign Up',
    },
    CapsLockWarning: {
        cmsId: 287921,
        defaultTranslation: 'Caps Lock is on',
    },
};
